import axios from 'axios'
import { getHeaders, getBase, getWebBase } from '../utils/requests'

axios.defaults.withCredentials = true

export const updateDesign = (design, generatePreview, forceSave) => {
  const base = getBase()
  let query = generatePreview ? '?generate=true' : ''
  if(forceSave){
    query += query.length === 0 ? '?' : '&'
    query += 'forceSave=true'
  }
  return axios.post(`${base}/design/save${query}`, design, {
      headers: {
        contentType: 'application/jsonrequest'
      },
      withCredentials: true
    })
}

export const fetchDesignJSON = publicId => {
  return axios.get(`${getBase()}/design/design-json?publicId=${publicId}`, {
    withCredentials: true
  })
}

export const fetchDesign = async designId => {
  const base = getBase()
  const res = await axios.get(`${base}/design/fetch?id=${designId}`, {
    withCredentials: true
  })
  return res.data
}

export const deleteDesign = async designId => {
  return await axios.delete(`${getBase()}/design?designId=${designId}`)
}

export const duplicateDesign = async (pages, title, publicId) => {
  return await axios.post(`${getBase()}/design/duplicate`, { pages, title, publicId }, {
    withCredentials: true
  })
}

export const fetchDesignHTML = async designId => {
  const base = getBase()
  const res = await axios.get(`${base}/design/view?id=${designId}`, {
    withCredentials: true
  })
  return res.data
}

export const getNFTUrl = async designId => {
  const res = await axios.post(`${getBase()}/design/create-nft`, { designId }, {
    withCredentials: true
  })
  return res.data
}

export const getAdminCategories = async (visibleOnly = false) => {
  let path = '/design/category-list'
  if(visibleOnly){
    path += '?visibleOnly=true'
  }
  const res = await axios.get(`${getBase()}${path}`)
  return res.data
}

export const mintNFT = async (name, description, wallet, image, link, supply = 1) => {
  const body = {
    name,
    description,
    wallet,
    image,
    link,
    supply
  }
  const res = await axios.post(`${getWebBase()}/profile/nft/upload`, body, {
    withCredentials: true,
    headers: {
      'Access-Control-Allow-Origin': '*'
    }
  })
  return res.data
}

export const adminUpdate = async body => {
  const res = await axios.post(`${getBase()}/design/update/admin`, body, {
    withCredentials: true
  })
  return res.data
}

export const getUserDesigns = async (keyword, team) => {  
  let path = `/design/user-templates`
  if(keyword && keyword.length){
    path += `?keyword=${keyword}`
  }
  if(team){
    path += `${keyword ? '&' : '?'}team=${team}`
  }
  const res = await axios.get(`${getBase()}${path}`, {
    withCredentials: true
  })
  return res.data
}

export const getPublicDesigns = async (category, page, keyword) => {
  let path = `/design/design-templates?category=${category}&page=${page}`
  if(keyword && keyword.length){
    path += `&keyword=${keyword}`
  }
  const res = await axios.get(`${getBase()}${path}`, {
    withCredentials: true
  })
  return res.data
}

export const getPublicDesign = async id => {
  const res = await axios.get(`${getBase()}/design/design-template?designId=${id}`)
  return res.data
}

export const updateDesignProperties = async (designId, body) => {
  const base = getBase()
  return await axios.put(`${base}/design/update`, { designId, ...body }, {
    withCredentials: true
  })
}

export const getDesignImage = async (designId, type, download = false) => {
  let params = `?type=${type}&designId=${designId}`
  if(download){
    params += `&download=${download}`
  }
  const base = getBase()
  return await axios.get(`${base}/design/download${params}`, {
    withCredentials: true
  })
}

export const incrementDesignClick = async (designId, userDesignId) => {
  const data = { designId, userDesignId }
  await axios.post(`${getBase()}/design/copy`, data, { withCredentials: true })
}

export const unLinkPublicDesign = async (designId) => {
  const data = { designId }
  await axios.post(`${getBase()}/design/unlink`, data, { withCredentials: true })
}

export const getBrands = async designId => {
  const res = await axios.get(`${getBase()}/design/brands?designId=${designId}`, {
    withCredentials: true
  })
  return res.data
}

export const saveBrand = async (name, publicId) => {
  const body = {name, publicId}
  const res = await axios.post(`${getBase()}/design/brands/save`, body, {
    withCredentials: true,
    headers: {
      contentType: 'application/jsonrequest'
    }
  })
  return res.data
}

export const attachDesignToBrand = async (publicId, projectId) => {
  const body = {projectId, publicId}
  const res = await axios.put(`${getBase()}/design/brands/attach`, body, {
    withCredentials: true
  })
  return res.data
}

export const fetchHTMLPreview = async (publicId) => {
  const res = await axios.get(`${getBase()}/design/preview?publicId=${publicId}`, {
    withCredentials: true
  })
  return res.data
}

export const fetchEmbedDesign = async publicId => {
  const res = await axios.get(`${getBase()}/design/embed?publicId=${publicId}`, {
    withCredentials: true
  })
  return res.data
}